function brandSectionFormDialog () {
  return {
    restrict: 'E',
    templateUrl: '/brand/dialogs/brand-section-form/brand-section-form-dialog.html?$$REVISION$$'
  }
}
export { brandSectionFormDialog }
